/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { FormControl, FormGroup } from '@angular/forms';
import { ShipmentDraftDTO } from '../index';
import { RouteDraftDtoModel, AbstractRouteVoModel } from '@well/route-management/domain';

export class ShipmentGroupSolutionSegmentDtoModel extends JSONable {
  uuid: string | undefined = undefined;

  temporaryId: string | undefined = undefined;

  shipmentDraftDTOs: ShipmentDraftDTO[] | undefined = undefined;

  shipmentDraftsGroupUuid: string | undefined = undefined;

  routeVo: AbstractRouteVoModel | undefined = undefined;

  routeTemplateVo: AbstractRouteVoModel | undefined = undefined;

  vendorRouteVo: AbstractRouteVoModel | undefined = undefined;

  previousSegment: ShipmentGroupSolutionSegmentDtoModel | undefined = undefined;

  firstSegmentInSolution: boolean | undefined = undefined;

  routeDraftDto: RouteDraftDtoModel | undefined = undefined;

  static createForm(): FormGroup {
    return new FormGroup({
      uuid: new FormControl(),
      temporaryId: new FormControl(),
      shipmentDraftDTOs: new FormControl(),
      shipmentDraftsGroupUuid: new FormControl(),
      routeVo: new FormControl(),
      routeTemplateVo: new FormControl(),
      vendorRouteVo: new FormControl(),
      previousSegment: new FormControl(),
      firstSegmentInSolution: new FormControl(),
    });
  }
}
